export interface OmniDeviceMapping {
    hardwareId?: string;  // MQTT 傳來的硬體編碼 (如 3_1-00)
    internalId?: string;   // 系統畫布使用的虛擬碼 (如 10)
    name: string;         // 前端 UI 顯示的名稱 (也作為關聯的主鍵)
    deviceId: string;     // 後端與外部系統對接的 DeviceID
    type: 'AC' | 'POWER' | 'LIGHT' | 'CCTV' | 'DOOR' | 'FAN' | 'AIR_QUALITY' | 'HOST' | 'PANEL' | 'RB';
}

/**
 * 【單一資料來源】
 * 集中管理所有基礎設備的軟硬體映射關係。
 * 未來如果有改名、增減點位等需求，只要維護這個陣列即可！
 */
export const ALL_DEVICES_MAPPING: OmniDeviceMapping[] = [
    // ---------- 門禁系統 (DOOR) ----------
    { hardwareId: '23', internalId: '1', name: '門禁_14F-001', deviceId: 'AC-14-0001', type: 'DOOR' },

    // ---------- CCTV監視系統 (CCTV) ----------
    { name: 'CCTV_14F-001', deviceId: 'VS-14-0001', type: 'CCTV' },
    { name: 'CCTV_14F-002', deviceId: 'VS-14-0002', type: 'CCTV' },
    { name: 'CCTV_14F-003', deviceId: 'VS-14-0003', type: 'CCTV' },
    { name: 'CCTV_14F-004', deviceId: 'VS-14-0004', type: 'CCTV' },
    { name: 'CCTV_15F-001', deviceId: 'VS-15-0001', type: 'CCTV' },
    { name: 'CCTV_15F-002', deviceId: 'VS-15-0002', type: 'CCTV' },
    { name: 'CCTV_15F-003', deviceId: 'VS-15-0003', type: 'CCTV' },
    { name: 'CCTV_15F-004', deviceId: 'VS-15-0004', type: 'CCTV' },

    // ---------- 空調系統 (AC) ----------
    { hardwareId: '4_1-00', internalId: '10', name: '冷氣室內機_14F-001', deviceId: 'HV-14-0001', type: 'AC' },
    { hardwareId: '4_1-01', internalId: '11', name: '冷氣室內機_14F-002', deviceId: 'HV-14-0002', type: 'AC' },
    { hardwareId: '4_1-02', internalId: '12', name: '冷氣室內機_14F-003', deviceId: 'HV-14-0003', type: 'AC' },
    { hardwareId: '4_1-03', internalId: '13', name: '冷氣室內機_14F-004', deviceId: 'HV-14-0004', type: 'AC' },
    { hardwareId: '4_1-04', internalId: '14', name: '冷氣室內機_14F-005', deviceId: 'HV-14-0005', type: 'AC' },
    { hardwareId: '4_1-05', internalId: '15', name: '冷氣室內機_14F-006', deviceId: 'HV-14-0006', type: 'AC' },
    { hardwareId: '4_1-06', internalId: '16', name: '冷氣室內機_14F-007', deviceId: 'HV-14-0007', type: 'AC' },
    { hardwareId: '3_1-12', internalId: '17', name: '冷氣室內機_14F-008', deviceId: 'HV-14-0008', type: 'AC' },
    { hardwareId: '3_1-13', internalId: '18', name: '冷氣室內機_14F-009', deviceId: 'HV-14-0009', type: 'AC' },
    { hardwareId: '4_1-07', internalId: '19', name: '冷氣室內機_14F-010', deviceId: 'HV-14-0010', type: 'AC' },
    { hardwareId: '5_1-00', internalId: '20', name: '冷氣室內機_15F-001', deviceId: 'HV-15-0001', type: 'AC' },
    { hardwareId: '5_1-01', internalId: '21', name: '冷氣室內機_15F-002', deviceId: 'HV-15-0002', type: 'AC' },
    { hardwareId: '5_1-02', internalId: '22', name: '冷氣室內機_15F-003', deviceId: 'HV-15-0003', type: 'AC' },
    { hardwareId: '5_1-03', internalId: '23', name: '冷氣室內機_15F-004', deviceId: 'HV-15-0004', type: 'AC' },
    { hardwareId: '5_1-04', internalId: '24', name: '冷氣室內機_15F-005', deviceId: 'HV-15-0005', type: 'AC' },
    { hardwareId: '5_1-06', internalId: '25', name: '冷氣室內機_15F-006', deviceId: 'HV-15-0006', type: 'AC' },
    { hardwareId: '5_1-07', internalId: '26', name: '冷氣室內機_15F-007', deviceId: 'HV-15-0007', type: 'AC' },
    { hardwareId: '5_1-05', internalId: '27', name: '冷氣室內機_15F-008', deviceId: 'HV-15-0008', type: 'AC' },

    // ---------- 風機系統 (FAN) ----------
    { hardwareId: '10', internalId: '28', name: '全熱交換器_14F-001', deviceId: 'VE-14-0001', type: 'FAN' },
    { hardwareId: '11', internalId: '29', name: '全熱交換器_15F-001', deviceId: 'VE-15-0001', type: 'FAN' },

    // ---------- 空氣品質系統 (AIR_QUALITY) ----------
    { hardwareId: '9', internalId: '30', name: '空氣品質偵測器_14F-001', deviceId: 'AQ-14-0001', type: 'AIR_QUALITY' },

    // ---------- 照明系統 (LIGHT) ----------
    { hardwareId: '1', internalId: '31', name: '照明控盤_14F-001', deviceId: 'LT-14-0001', type: 'LIGHT' },
    { hardwareId: '2', internalId: '32', name: '照明控盤_15F-001', deviceId: 'LT-15-0001', type: 'LIGHT' },

    // ---------- 電力系統 (POWER) ----------
    { hardwareId: '4', internalId: '33', name: '電錶_14F-001', deviceId: 'PW-14-0001', type: 'POWER' },
    { hardwareId: '5', internalId: '34', name: '電錶_14F-002', deviceId: 'PW-14-0002', type: 'POWER' },
    { hardwareId: '6', internalId: '35', name: '電錶_14F-003', deviceId: 'PW-14-0003', type: 'POWER' },
    { hardwareId: '7', internalId: '36', name: '電錶_14F-004', deviceId: 'PW-14-0004', type: 'POWER' },
    { hardwareId: '8', internalId: '37', name: '電錶_14F-005', deviceId: 'PW-14-0005', type: 'POWER' },
    { hardwareId: '1', internalId: '38', name: '電錶_15F-001', deviceId: 'PW-15-0001', type: 'POWER' },
    { hardwareId: '2', internalId: '39', name: '電錶_15F-002', deviceId: 'PW-15-0002', type: 'POWER' },
    { hardwareId: '3', internalId: '40', name: '電錶_15F-003', deviceId: 'PW-15-0003', type: 'POWER' },

    // ---------- 會議室系統關聯 (PANEL, RB, HOST) ----------
    { internalId: '40', name: '會議室面板_14F-001', deviceId: 'MR-14-0001', type: 'PANEL' },
    { internalId: '41', name: '會議室面板_14F-002', deviceId: 'MR-14-0002', type: 'PANEL' },
    { internalId: '42', name: '會議室面板_14F-003', deviceId: 'MR-14-0003', type: 'PANEL' },
    { internalId: '43', name: '會議室面板_14F-004', deviceId: 'MR-14-0004', type: 'PANEL' },
    { internalId: '44', name: '會議室面板_14F-005', deviceId: 'MR-14-0005', type: 'PANEL' },
    { internalId: '45', name: '會議室面板_14F-006', deviceId: 'MR-14-0006', type: 'PANEL' },
    { internalId: '46', name: '會議室面板_15F-001', deviceId: 'MR-15-0001', type: 'PANEL' },
    { internalId: '47', name: '會議室面板_15F-002', deviceId: 'MR-15-0002', type: 'PANEL' },
    { internalId: '48', name: '會議室面板_15F-003', deviceId: 'MR-15-0003', type: 'PANEL' },
    { internalId: '49', name: '會議室面板_15F-004', deviceId: 'MR-15-0004', type: 'PANEL' },
    { internalId: '50', name: '會議室面板_15F-005', deviceId: 'MR-15-0005', type: 'PANEL' },

    { internalId: '51', name: '捲簾_14F-001', deviceId: 'MR-14-0007', type: 'RB' },
    { internalId: '52', name: '捲簾_14F-002', deviceId: 'MR-14-0008', type: 'RB' },
    { internalId: '53', name: '捲簾_14F-003', deviceId: 'MR-14-0009', type: 'RB' },
    { internalId: '54', name: '捲簾_14F-004', deviceId: 'MR-14-0010', type: 'RB' },
    { internalId: '55', name: '捲簾_14F-005', deviceId: 'MR-14-0011', type: 'RB' },
    { internalId: '56', name: '捲簾_15F-001', deviceId: 'MR-15-0006', type: 'RB' },
    { internalId: '57', name: '捲簾_15F-002', deviceId: 'MR-15-0007', type: 'RB' },
    { internalId: '58', name: '捲簾_15F-003', deviceId: 'MR-15-0008', type: 'RB' },
    { internalId: '59', name: '捲簾_15F-004', deviceId: 'MR-15-0009', type: 'RB' },

    { internalId: '60', name: '環控主機_14F-001', deviceId: 'MR-14-0012', type: 'HOST' },
    { internalId: '61', name: '環控主機_14F-002', deviceId: 'MR-14-0013', type: 'HOST' },
    { internalId: '62', name: '環控主機_14F-003', deviceId: 'MR-14-0014', type: 'HOST' },
    { internalId: '63', name: '環控主機_14F-004', deviceId: 'MR-14-0015', type: 'HOST' },
    { internalId: '64', name: '環控主機_14F-005', deviceId: 'MR-14-0016', type: 'HOST' },
    { internalId: '65', name: '環控主機_14F-006', deviceId: 'MR-14-0017', type: 'HOST' },
    { internalId: '66', name: '環控主機_15F-001', deviceId: 'MR-15-0010', type: 'HOST' },
    { internalId: '67', name: '環控主機_15F-002', deviceId: 'MR-15-0011', type: 'HOST' },
    { internalId: '68', name: '環控主機_15F-003', deviceId: 'MR-15-0012', type: 'HOST' },
    { internalId: '69', name: '環控主機_15F-004', deviceId: 'MR-15-0013', type: 'HOST' },
    { internalId: '70', name: '環控主機_15F-005', deviceId: 'MR-15-0014', type: 'HOST' },
];

/**
 * 會議室複合情境映射 (1 對多)
 * 由於 Modbus 硬體配置特殊，必須獨立維護 1 對多的廣播。
 * 在這裡依然可以將其獨立，方便直觀管理。
 */
export const ROOM_SYSTEM_MAPPING: { [key: string]: { host: string, panel: string, rb: string[], name: string } } = {
    '12': { host: '60', panel: '40', rb: ['51', '52', '53'], name: '會議室_14F-001' },
    '13': { host: '61', panel: '41', rb: ['54', '55'], name: '會議室_14F-002' },
    '14': { host: '62', panel: '42', rb: [], name: '會議室_14F-003' },
    '15': { host: '63', panel: '43', rb: [], name: '會議室_14F-004' },
    '16': { host: '64', panel: '44', rb: [], name: '會議室_14F-005' },
    '17': { host: '65', panel: '45', rb: [], name: '會議室_14F-006' },
    '18': { host: '66', panel: '46', rb: [], name: '會議室_15F-001' },
    '19': { host: '67', panel: '47', rb: ['58', '59'], name: '會議室_15F-002' },
    '20': { host: '68', panel: '48', rb: ['56', '57'], name: '會議室_15F-003' },
    '21': { host: '69', panel: '49', rb: [], name: '會議室_15F-004' },
    '22': { host: '70', panel: '50', rb: [], name: '會議室_15F-005' }
};

// =======================================================
// === 以下是為了完美橋接原本 Service 中 O(1) 查表邏輯的封裝 ===
// =======================================================
export const AC_ID_MAPPING: Record<string, string> = {};
export const POWER_ID_MAPPING: Record<string, string> = {};
export const LIGHT_ID_MAPPING: Record<string, string> = {};
export const FAN_ID_MAPPING: Record<string, string> = {};
export const DOOR_ID_MAPPING: Record<string, string> = {};

export const AC_NAME_MAPPING: Record<string, string> = {};
export const POWER_NAME_MAPPING: Record<string, string> = {};
export const LIGHT_NAME_MAPPING: Record<string, string> = {};
export const RB_NAME_MAPPING: Record<string, string> = {};
export const FAN_NAME_MAPPING: Record<string, string> = {};
export const DOOR_NAME_MAPPING: Record<string, string> = {};

export const CUSTOM_DEVICE_ID_MAPPING: Record<string, string> = {};

ALL_DEVICES_MAPPING.forEach(item => {
    // 綁定 DeviceId (以名為 Key)
    CUSTOM_DEVICE_ID_MAPPING[item.name] = item.deviceId;

    // 依據類型綁定前後端映射
    if (item.type === 'AC' && item.hardwareId && item.internalId) {
        AC_ID_MAPPING[item.hardwareId] = item.internalId;
        AC_NAME_MAPPING[item.internalId] = item.name;
    } else if (item.type === 'POWER' && item.hardwareId && item.internalId) {
        POWER_ID_MAPPING[item.hardwareId] = item.internalId;
        POWER_NAME_MAPPING[item.internalId] = item.name;
    } else if (item.type === 'LIGHT' && item.hardwareId && item.internalId) {
        LIGHT_ID_MAPPING[item.hardwareId] = item.internalId;
        LIGHT_NAME_MAPPING[item.internalId] = item.name;
    } else if (item.type === 'RB' && item.internalId) {
        RB_NAME_MAPPING[item.internalId] = item.name;
    } else if (item.type === 'FAN' && item.hardwareId && item.internalId) {
        FAN_ID_MAPPING[item.hardwareId] = item.internalId;
        FAN_NAME_MAPPING[item.internalId] = item.name;
    } else if (item.type === 'DOOR' && item.hardwareId && item.internalId) {
        DOOR_ID_MAPPING[item.hardwareId] = item.internalId;
        DOOR_NAME_MAPPING[item.internalId] = item.name;
    }
});

export interface PointMappingConfig {
    dialogType: 'input' | 'select' | 'toggle';
    options?: Record<string, string>;
    valueFormatter?: (value: number | string) => string;
}

export const EQUIPMENT_POINT_TAG_MAPPING: Record<string, Record<string, PointMappingConfig>> = {
    '冷氣室內機': {
        'ErrorStatus': { dialogType: 'select', options: { '0': '正常', '1': '異常' } },
        'Power': { dialogType: 'toggle', options: { '0': '關機', '1': '開機' } },
        'Mode': { dialogType: 'select', options: { '0': '送風','2': '冷氣', '7': '除濕' } },
        'FanSpeed': { dialogType: 'select', options: { '0': '自動', '1': '弱', '3': '中', '5': '強' } },
        'Swing': { dialogType: 'select', options: { '0': '水平', '1': '往下25度', '2': '往下50度', '3': '往下75度', '4': '垂直', '7': '擺動' } }
    },
    '電錶': {
        'ErrStatus': { dialogType: 'toggle', options: { '0': '連線中', '1': '離線' } },
    },
    '全熱交換器': {
        '01_Power': { dialogType: 'toggle', options: { '0': '關機', '1': '開機' } },
        '02_ErrorStatus': { dialogType: 'select', options: { '0': '正常', '1': 'EA馬達異常', '2': 'SA馬達異常', '14':'液態控制器操作異常', '16':'本體迴路異常', '17':'主子機間通訊異常', '18':'本體迴路異常(子機)', '19':'EA馬達異常(子機)', '20':'SA馬達異常(子機)' } },
        '01_ErrStatus': { 
            dialogType: 'toggle', 
            options: { '0': '連線中', '1': '離線' },
            valueFormatter: (value) => {
                const num = Number(value);
                if (isNaN(num)) return String(value);
                return num > 0 ? '離線' : '連線中';
            }
        },
        '01_RunMode': { dialogType: 'select', options: { '0': '全熱換氣', '1': '普通換氣' } },
        '01_FanSpeed': { dialogType: 'select', options: { '1': '弱', '3': '強' } },
        '02_FilterCycle': { dialogType: 'select', options: { '1': '120','2':'150', '3': '180' } },
    },
    '空氣品質偵測器': {
        'ErrStatus': { dialogType: 'select', options: { '0': '連線中', '1': '離線' } },
        'V1_Comfort': { 
            dialogType: 'input',
            valueFormatter: (value) => {
                const num = Number(value);
                if (isNaN(num)) return String(value);
                let status = '';
                if (num < 18) status = '寒冷';
                else if (num < 27) status = '舒適';
                else if (num < 31) status = '炎熱';
                else status = '酷熱';
                return `${value}(${status})`;
            }
        },
        'V1_AQI': { 
            dialogType: 'input',
            valueFormatter: (value) => {
                const num = Number(value);
                if (isNaN(num)) return String(value);
                let status = '';
                if (num <= 100) status = '良';
                else if (num <= 200) status = '警示';
                else status = '危害';
                return `${value}(${status})`;
            }
        },
    },
    '門禁': {
        '01_Door_Status': { dialogType: 'select', options: { '0': '關門', '1': '開門' } },
        '01_Arm_Status': { dialogType: 'select', options: { '0': '解除警戒', '1': '警戒' } },
        '01_Btn_Status': { dialogType: 'select', options: { '0': '停用', '1': '啟用' } },
        '01_Online_Status': { dialogType: 'select', options: { '0': '離線', '1': '連線中' } },
        '01_Door_Open_Too_Long': { dialogType: 'select', options: { '0': '正常', '1': '異常' } }
    },
    'CCTV': {
        // 根據mqtt裡的isOnline，0為離線 1為連線中
        'Online': { dialogType: 'select', options: { '0': '離線', '1': '連線中' } }
    },
    '照明控盤': {
        'Point': { dialogType: 'toggle', options: { '0': '關燈', '1': '開燈' } }
    },
    '環控主機': {
        // 根據mqtt裡的isOnline，0為離線 1為連線中
        'Online': { dialogType: 'select', options: { '0': '離線', '1': '連線中' } }
    },
    '會議室面板': {
        '01_1': { dialogType: 'select', options: { '0': '閒置中', '1': '已預約', '2': '使用中' } },
        '01_3': { dialogType: 'select', options: { '0': '連線中', '1': '離線' } }
    },
    '捲簾': {
        '01_2': { 
            dialogType: 'select', 
            valueFormatter: (val: any) => {
                if (val == 0) return '全收';
                if (val == 100) return '全放';
                return '中間';
            },
            options: { '0': '全收', '50': '中間', '100': '全放' } 
        },
        '01_4': { dialogType: 'select', options: { '0': '連線中', '1': '離線' } }
    }
};

/**
 * 根據告警點位路徑 (point) 解析出真正的設備名稱。
 * 解決會議室系統 (MODBUS|RoomId|PointId) 告警掛載在環控主機上的問題。
 */
export function resolveDeviceNamesFromPoint(point: string, originalDeviceName: string): string[] {
    if (!point || !point.startsWith('MODBUS|')) {
        return [originalDeviceName];
    }

    const parts = point.split('|');
    if (parts.length < 3) return [originalDeviceName];

    const roomId = parts[1];
    const funId = parts[2];
    const roomMap = ROOM_SYSTEM_MAPPING[roomId];

    if (!roomMap) return [originalDeviceName];

    // 捲簾點位 (01_2: 狀態, 01_4: 通訊)
    if (['01_2', '01_4'].includes(funId)) {
        if (roomMap.rb && roomMap.rb.length > 0) {
            return roomMap.rb.map(rbId => RB_NAME_MAPPING[rbId] || `捲簾_${rbId}`);
        }
    }

    // 面板點位 (01_1: 使用狀態, 01_3: 通訊)
    if (['01_1', '01_3'].includes(funId)) {
        return [roomMap.name.replace('會議室', '會議室面板')];
    }

    return [originalDeviceName];
}
